/*
 * @Author: ningbo.kang
 * @Date: 2020-11-17 14:49:16
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-07-10 13:27:21
 * @Description: 描述 zh_CN 语言包
 */
export default {
  wg: {
    required: '{0}必须填写',
    invalidType: '无效的数据格式',
    batchDel: '批量删除',
    sn: '序号',
    searchKey: '请输入关键字进行搜索',
    select: '请选择',
    treeSelectPlaceholder: '请输入关键字进行搜索',
    inputPlaceholder: '请输入...',
    createAt: '提交于',
    searchproname: '支持流程主题、流程名称模糊搜索',
    selectFlow: '请选择关联审批单',
    drafter: '发起人：',
    drafterDept: '发起部门：',
    bt: {
      filter: '查询条件',
      query: '查询',
      reset: '重置',
      delete: '删除',
      operation: '操作',
      confirm: '确认',
      cancel: '取消',
      addLinks: '添加关联流程',
    },
    file: {
      bt: '点击上传',
      preview: '预览',
      download: '下载',
      upload: '上传',
      unupload: '未上传',
      msg: '仅允许上传图片类型，jpg,png,gif',
    },
    table: {
      add: '新增',
      delete: '删除',
      batchDel: '批量删除',
      confirm: '您确定要批量删除吗？',
      confirmRow: '您确定要删除这行数据吗',
      table: '表格',
      panel: '面板',
      tableTip: '切换表格显示模式',
      panleTip: '切换面板显示模式',
      import: '导入',
      upload: '模版下载',
    },
    status: {
      running: '审批中',
      end: '已归档',
      back: '已驳回',
      revoke: '已撤销',
      manualend: '已作废',
    },
  },
};
